import { addDays } from 'date-fns'
import { TFunction } from 'i18next'

import { DEFAULT_CURRENCY } from '@features/invoices/constants/defaultCurrency'
import { DEFAULT_INVOICE_PAYMENT_TERM } from '@features/invoices/constants/defaultInvoicePaymentTerm'
import { InvoiceDiscountType } from '@features/invoices/enums/invoiceDiscountType'
import { InvoiceForm } from '@features/invoices/types/invoiceForm/invoiceForm'
import { Organization } from '@modules-deprecated/app/organization/types/organization'

import { DEMO_INVOICE_CUSTOMERS } from '../constants/demoInvoiceCustomers'
import { DEMO_INVOICE_NUMBER, DEMO_INVOICE_NUMBER_PREFIX } from '../constants/demoInvoiceNumber'
import { DEMO_INVOICE_PRODUCTS } from '../constants/demoInvoiceProducts'
import { getDemoInvoiceLanguage } from './getDemoInvoiceLanguage'
import { getDemoInvoiceReceiver } from './getDemoInvoiceReceiver'
import { getDemoInvoiceRowLine } from './getDemoInvoiceRowLine'

interface GetDemoInvoiceFormDefaultValuesOptions {
  language: string
  organization?: Organization
  t: TFunction
}

export const getDemoInvoiceFormDefaultValues = ({
  language,
  organization,
  t,
}: GetDemoInvoiceFormDefaultValuesOptions): InvoiceForm => {
  const now = new Date()
  const [defaultCustomer] = DEMO_INVOICE_CUSTOMERS
  const [firstProduct, secondProduct] = DEMO_INVOICE_PRODUCTS
  const paymentTerm = defaultCustomer.paymentTermsDays ?? DEFAULT_INVOICE_PAYMENT_TERM

  return {
    currency: organization?.baseCurrencyId || DEFAULT_CURRENCY,
    dateOfSaleOrService: now,
    discount: 0,
    discountType: InvoiceDiscountType.Percentage,
    displayedPaymentMethods: { bank: true, offlinePayment: true, paypal: true },
    dueDate: addDays(now, paymentTerm),
    footerNote: t('demo_invoice.fixtures.footer_note'),
    invoiceLines: [getDemoInvoiceRowLine(firstProduct, t), getDemoInvoiceRowLine(secondProduct, t, 3)],
    invoiceNumber: DEMO_INVOICE_NUMBER,
    invoiceNumberPrefix: DEMO_INVOICE_NUMBER_PREFIX,
    issueDate: now,
    language: getDemoInvoiceLanguage(language),
    message: t('demo_invoice.fixtures.message'),
    paymentTerm,
    receiver: getDemoInvoiceReceiver(defaultCustomer, t),
  }
}
